import styled from "styled-components";
import { BodyDefault } from "../typography/styled";

type ActiveProp = {
  active?:boolean,
  isSmall?:any,
  hideSideBar?:boolean
}
export const Container = styled.div<ActiveProp>`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  max-width: 100%;
  transition: 0.2s width ease-in-out;
  z-index: 2;
  padding: 20px 30px;
  height:80px;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  position: relative;
  background-color: ${({theme}) => theme.palette[10]};

  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: 40px;
    width: 100%;
    height: 70px;
    min-height: 70px;
    padding: 15px 16px;
    gap: 8px;
  }

  @media screen and (max-width: 600px) {
    padding: 15px 16px;
  }

  @media screen and (max-width: 359px) {
    grid-template-rows: 40px 40px;
    height: auto;
    min-height: 118px;
  }
`

export const HeaderLeft = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;

  @media screen and (max-width: 768px) {
    grid-column: 1;
    grid-row: 1;
  }
`

export const SearchContainer = styled.div<ActiveProp>`
  flex: 1 1 650px;
  width: 100%;
  max-width: 650px;
  min-width: 0;

  @media screen and (max-width: 900px) {
    display: ${({isSmall}) => isSmall ? 'block' : 'none'};
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`

export const HamburgerButton = styled.button`
  display: none;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  margin-right: 12px;
  padding: 10px 8px;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
  border: ${({theme}) => `1px solid ${theme.neutral[15]}`};
  border-radius: ${({theme}) => theme.radius.search};
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => theme.shadows.card};
  cursor: pointer;

  @media screen and (max-width: 768px) {
    display: flex;
    margin-right: 0;
  }

  span {
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background-color: ${({theme}) => theme.palette[800]};
  }
`
export const RightSideContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 40px;
  height: 40px;
  flex-shrink: 0;
  z-index: 6;

  @media screen and (max-width: 1280px) {
    gap: 12px;
  }

  @media screen and (max-width: 768px) {
    display: contents;
  }
`

export const HeaderControlsCluster = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  height: 40px;
  flex-shrink: 0;

  @media screen and (max-width: 1280px) {
    gap: 12px;
  }

  @media screen and (max-width: 768px) {
    grid-column: 2;
    grid-row: 1;
    justify-content: flex-end;
    width: 100%;
    min-width: 0;
    gap: 8px;
  }

  @media screen and (max-width: 359px) {
    grid-column: 1 / -1;
    grid-row: 2;
  }

  > div:first-child > div > div:last-child p {
    font-size: 14px;
    line-height: 20px;
    color: ${({theme}) => theme.palette[900]};
  }
`

export const IconActionsContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 78px;
  height: 40px;
  padding: 2px 8px 2px 9px;
  border-radius: ${({theme}) => theme.radius.search};
  border: ${({theme}) => `1px solid ${theme.neutral[15]}`};
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => theme.shadows.card};

  img,
  svg {
    flex-shrink: 0;
  }

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    cursor: pointer;
    transition: opacity 0.15s ease-in-out;
  }

  img:hover {
    opacity: 0.75;
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`

export const ProfileContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 190px;
  height: 40px;
  padding: 2px 7px 2px 9px;
  border-radius: ${({theme}) => theme.radius.search};
  border: ${({theme}) => `1px solid ${theme.neutral[15]}`};
  background-color: ${({theme}) => theme.palette[10]};
  box-shadow: ${({theme}) => theme.shadows.card};
  z-index: 2;
  &:hover{
    cursor: pointer;
  }

  @media screen and (max-width: 1280px) {
    justify-content: space-between;
    width: 62px;
    min-width: 62px;
    height: 40px;
    padding: 2px 7px;
  }

  @media screen and (max-width: 768px) {
    grid-column: 3;
    grid-row: 1;
  }
`
export const ChevronIc = styled.img<ActiveProp>`
  transform: ${({active}) => active ? 'rotate(180deg)' : ''};
  transition: 0.2s transform ease-in-out;
`

export const NoAvatar = styled.div`
  text-align: center;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width:24px;
  height:24px;
  border-radius: 100%;
  color:${({theme}) => theme.palette[650]};
  background-color: ${({theme}) => theme.palette[400]};
`


export const ProfileName = styled(BodyDefault)`
  color:${({theme}) => theme.palette[900]};
  display: block;
  width: 116px;
  flex-shrink: 0;
  margin-left: 12px;
  margin-right: 4px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;

  @media screen and (max-width: 1280px) {
    display: none;
  }
`

export const DropDownProfile = styled.div<ActiveProp>`
  box-sizing: border-box;
  padding: 4px 0px;
  right: 26px;
  top: 60px;
  z-index: 6;
  position: absolute;
  background-color: ${({theme}) => theme.palette[10]};
  width: 240px;
  /* height: 244px; */
  border:${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius:${({theme}) => theme.radius.control};
  box-shadow: ${({theme}) => `${theme.shadows.hover}, ${theme.shadows.menu}`};
  transform:${({active}) => active ? 'scale(1)' : 'scale(0)'};
  opacity:${({active}) => active ? '1' : '0'};
  transform-origin: top center;
  transition-property: transform, opacity;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;
`

export const NotificationsContainer = styled.div<ActiveProp>`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  z-index: 6;
  width: 400px;
  max-height: 430px;
  right:80px;
  top:60px;
  padding: 16px 15px 14px;
  background: ${({theme}) => theme.palette[10]};
  border: ${({theme}) => `1px solid ${theme.grey[350]}`};
  box-shadow: ${({theme}) => theme.shadows.menu};
  border-radius: 8px;
  transform:${({active}) => active ? 'scale(1)' : 'scale(0)'};
  opacity:${({active}) => active ? '1' : '0'};
  transform-origin: top center;
  transition-property: transform, opacity;
  transition-duration: 0.2s;
  transition-timing-function: ease-out;

  @media screen and (max-width: 600px) {
    width: calc(100% - 32px);
    right: 16px;
  }
`

export const BalanceContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction:column;
  width: auto;
  min-width: 114px;
  height: 40px;
  flex-shrink: 0;
  background-color: ${({theme}) => theme.palette[10]};
  padding: 5px 8px 5px 10px;
  border: ${({theme}) =>  `1px solid ${theme.neutral[15]}`};
  border-radius: ${({theme}) => theme.radius.search};
  box-shadow: ${({theme}) => theme.shadows.card};
  color: ${({theme}) => theme.grey[600]};
  &:hover{
    cursor: pointer;
    color: ${({theme}) => theme.grey[900]};
  }

  @media screen and (max-width: 768px) {
    min-width: 114px;
    max-width: calc(100% - 95px);

    > div p {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`
